import { createSlice } from "@reduxjs/toolkit";

const initialState = {
  questions: [],
  aiQuestions: [],
  isFetchingQuestions: true,
  isFetchQuestion: true,
  question: null,
  isEditingQuestion: false,
  error: null,
  isDeletingQuestion: false,
  isGeneratingSolution: false,
  generatedSolution: null,
  isMarkingQuestion: false,
  markedAnswer: null,
  schools:[],
  isFetchingSchools: true,
  isAddingKnowledge: true
};

export const questionsSlice = createSlice({
  name: "questions",
  initialState,
  reducers: {
    fetchQuestionsStart: (state, action) => {
      state.isFetchingQuestions = true;
      state.error = null;
    },
    fetchQuestionsSuccess: (state, action) => {
      state.isFetchingQuestions = false;
      state.questions = action.payload;
      state.error = null;
    },
    fetchQuestionsFailure: (state, action) => {
      state.isFetchingQuestions = false;
      state.questions = [];
      state.error = action.payload;
    },
    createQuestionStart: (state, action) => {
      state.isEditingQuestion = true;
    },
    createQuestionSuccess: (state, action) => {
      state.isEditingQuestion = false;
    },
    createQuestionsFailure: (state, action) => {
      state.isEditingQuestion = false;
      state.error = action.payload;
    },
    editQuestionStart: (state, action) => {
      state.isEditingQuestion = true;
    },
    editQuestionSuccess: (state, action) => {
      state.isEditingQuestion = false;
    },
    editQuestionFailure: (state, action) => {
      state.isEditingQuestion = false;
    },
    fetchQuestionStart: (state, action) => {
      state.isFetchQuestion = true;
    },
    fetchQuestionSuccess: (state, action) => {
      state.isFetchQuestion = false;
      state.question = action.payload;
    },
    fetchQuestionFailure: (state, action) => {
      state.isFetchQuestion = false;
      state.question = null;
    },
    resetIsFetchingQuestion: (state) => {
      state.isFetchQuestion = true;
    },
    deleteQuestionStart: (state, action) => {
      state.isDeletingQuestion = true;
    },
    deleteQuestionSuccess: (state) => {
      state.isDeletingQuestion = false;
    },
    deleteQuestionFailure: (state) => {
      state.isDeletingQuestion = false;
    },
    resetQuestion: (state) => {
      state.question = null;
    },
    createQuestionImageStart: (state) => {
      state.isEditingQuestion = true;
    },
    createQuestionImageSuccess: (state) => {
      state.isEditingQuestion = false;
    },
    createQuestionImageFailure: (state) => {
      state.isEditingQuestion = false;
    },
    editQuestionImageStart: (state) => {
      state.isEditingQuestion = true;
    },
    editQuestionImageSuccess: (state) => {
      state.isEditingQuestion = false;
    },
    editQuestionImageFailure: (state) => {
      state.isEditingQuestion = false;
    },
    generateSolutionStart: (state) => {
      state.isGeneratingSolution = true;
    },
    generateSolutionSuccess: (state, action) => {
      state.isGeneratingSolution = false;
      state.generatedSolution = action.payload;
    },
    generateSolutionFail: (state, action) => {
      state.isGeneratingSolution = false;
      state.generatedSolution = null;
    },
    resetGenerateSolution: (state, action) => {
      state.isGeneratingSolution = false;
      state.generatedSolution = null;
      state.markedAnswer = null;
    },
    generateMultipleSolutionStart: (state) => {
      state.isGeneratingSolution = true;
    },
    generateMultipleSolutionSuccess: (state, action) => {
      state.isGeneratingSolution = false;
      state.generatedSolution = action.payload;
    },
    generateMultipleSolutionFail: (state, action) => {
      state.isGeneratingSolution = false;
      state.generatedSolution = null;
      state.error = action.payload;
    },
    markAnswerStart: (state, action) => {
      state.isMarkingQuestion = true;
      state.markedAnswer = null;
      state.error = action.payload;
    },
    markAnswerSuccess: (state, action) => {
      state.isMarkingQuestion = false;
      state.markedAnswer = action.payload;
      state.error = null;
    },
    markAnswerFailure: (state, action) => {
      state.isMarkingQuestion = false;
      state.markedAnswer = null;
    },
    createBulkQuestionStart: (state, action) => {
      state.isEditingQuestion = true;
    },
    createBulkQuestionSuccess: (state, action) => {
      state.isEditingQuestion = false;
    },
    createBulkQuestionFailure: (state, action) => {
      state.isEditingQuestion = false;
      state.error = action.payload;
    },
    aiCreateQuestionStart: (state, action) => {
      state.isGeneratingSolution = true;
    },
    aiCreateQuestionSuccess: (state, action) => {
      state.isGeneratingSolution = false;
      state.aiQuestions = action.payload;
    },
    aiCreateQuestionFailure: (state, action) => {
      state.isGeneratingSolution = false;
      state.error = action.payload;
    },
    resetAIQuestions: (state, action) => {
      state.aiQuestions = [];
      state.isGeneratingSolution = false;
      state.error = null;
    },
    saveGeneratedQuestionStart: (state, action) => {
      state.isEditingQuestion = true;
    },
    saveGeneratedQuestionSuccess: (state, action) => {
      state.isEditingQuestion = false;
    },
    saveGeneratedQuestionsFailure: (state, action) => {
      state.isEditingQuestion = false;
      state.error = action.payload;
    },
    getSchoolsStart: (state, action) => {
      state.isFetchingSchools = true;
      state.error = null;
    },
    getSchoolsSuccess: (state, action) => {
      state.isFetchingSchools = false;
      state.schools = action.payload;
      state.error = null;
    },
    getSchoolsFailure: (state, action) => {
      state.isFetchingSchools = false;
      state.error = action.payload;
    },
    createAddKnowledgeStart: (state, action) => {
      state.isAddingKnowledge = true;
    },
    createAddKnowledgeStartSuccess: (state, action) => {
      state.isAddingKnowledge = false;
    },
    createAddKnowledgeStartFailure: (state, action) => {
      state.isAddingKnowledge = false;
      state.error = action.payload;
    },
  },
});

export const {
  fetchQuestionsFailure,
  fetchQuestionsStart,
  fetchQuestionsSuccess,
  createQuestionStart,
  createQuestionSuccess,
  createQuestionsFailure,
  editQuestionStart,
  editQuestionSuccess,
  editQuestionFailure,
  fetchQuestionStart,
  fetchQuestionSuccess,
  fetchQuestionFailure,
  resetIsFetchingQuestion,
  deleteQuestionStart,
  deleteQuestionSuccess,
  deleteQuestionFailure,
  resetQuestion,
  createQuestionImageStart,
  createQuestionImageSuccess,
  createQuestionImageFailure,
  editQuestionImageStart,
  editQuestionImageSuccess,
  editQuestionImageFailure,
  generateSolutionFail,
  generateSolutionStart,
  generateSolutionSuccess,
  resetGenerateSolution,
  markAnswerFailure,
  markAnswerSuccess,
  markAnswerStart,
  createBulkQuestionStart,
  createBulkQuestionSuccess,
  createBulkQuestionFailure,
  aiCreateQuestionStart,
  aiCreateQuestionSuccess,
  aiCreateQuestionFailure,
  resetAIQuestions,
  saveGeneratedQuestionStart,
  saveGeneratedQuestionSuccess,
  saveGeneratedQuestionFailure,
  getSchoolsStart,
  getSchoolsFailure,
  getSchoolsSuccess,
  createAddKnowledgeStart,
  createAddKnowledgeStartFailure,
  createAddKnowledgeStartSuccess
} = questionsSlice.actions;

const questionsReducer = questionsSlice.reducer;
export default questionsReducer;
